import { EventMap } from '@shared/types/interfaces/event';
import { loadEvents as loadEventsAction } from '../../store/thunks/events.thunk';
import { store } from '../../store/store';

export default function loadEvents(events: EventMap) {
  store.dispatch(loadEventsAction(events));
}
